module.exports = __webpack_public_path__ + "img/MISSION.9043f10b.png";